// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"01a9ce49","453":"c70883a4","498":"fe47b012","677":"b9670144","795":"361c1bcc","846":"be0810f6","910":"1a5e9fd5"}[chunkId] + ".chunk.js";
};